import {HeaderTitle} from "../../../common/HeaderTitle.jsx";
import ButtonWithIcon from "../../../common/ButtonWithIcon.jsx";
import {Icons} from "../../../common/Icons.jsx";
import {useDispatch} from "react-redux";
import {setSlownikFormSelected} from "../../../../redux/slownikFormSelected.js";
import {useNavigate} from "react-router-dom";
import {SimpleTable} from "../../../common/simpleTable/SimpleTable.jsx";
import {listaSlownikowColumns} from "../lib/columns/listaSlownikowColumns.js";
import {useSlowniki} from "../../../../api/domain/slowniki/queries/useSlowniki.jsx";
import {castSlownikiToTable} from "../../../utils/helpers/index.js";


const ViewListaSlownikow = () => {
    const titleName = 'Wszystkie słowniki';
    const dispatch = useDispatch()
    const navigate = useNavigate()


    const slowniki = useSlowniki()
    // const {data, isError, isLoading, refetch} = useSlowniki() // @alterjnatywny sposób użycia




    const handleForm = (selector = undefined) => {
        dispatch(setSlownikFormSelected({data: slowniki?.data?.[selector], name: selector}))
        return navigate(`/oper/slownik/${selector}/lista`);
    }

    const td = (row) => {
        return <td>
            <div className='d-flex gap-1'>
                <ButtonWithIcon
                    variant={'primary'}
                    size={'sm'} onClick={() => handleForm(row.unit)} icon={<Icons.playList/>}
                    title='Zarządzaj słownikiem'/>
            </div>
        </td>

    }

    return (
        <div>
            <>
                <HeaderTitle
                    breadcrumbLinks={[
                        {label: 'Wszystkie słowniki'},
                    ]}
                    home
                    destination={'/'}
                    size={'fs-3'}
                    nav
                    title={titleName}/>

                <SimpleTable
                    columns={listaSlownikowColumns}
                    addTh={() => <th>Operacje</th>}
                    addTd={td}
                    data={castSlownikiToTable(slowniki?.data)}
                />

            </>


        </div>
    );
}

export default ViewListaSlownikow;